export { default as FdrFooterFeedback } from './fdr-footer-feedback';
